import { createFileRoute } from '@tanstack/react-router';

import { PrivacyStatementPage } from '@apple/ui/shell/pages/PrivacyStatementPage';

export const Route = createFileRoute('/(public)/privacy')({
	component: PrivacyStatementPage,
});
